document.addEventListener('alpine:init', () => {
	Alpine.data('ds_combobox', (config = {}) => ({
		choicesInstance: null,

		init() {
			const selectEl = this.$refs.select || this.$el.querySelector('select') || this.$el;
			if (!selectEl || selectEl.tagName !== 'SELECT') return;

			// Initialize Choices.js
			let options = {
				removeItemButton: config.multiple || selectEl.hasAttribute('multiple'),
				searchEnabled: config.searchEnabled !== false,
				searchPlaceholderValue: config.searchPlaceholder || 'Search...',
				placeholder: true,
				placeholderValue: config.placeholder || 'Select...',
				itemSelectText: '',
				shouldSort: false,
				...config
			}
			options.placeholder = true
			delete options.searchPlaceholder
			delete options.multiple

			this.choicesInstance = new Choices(selectEl, options);
		},

		destroy() {
			if (this.choicesInstance) {
				this.choicesInstance.destroy();
			}
		}
	}));
});
